import React from 'react';

function DateOrDay(props) {
  const fill = props.fill || '#EEEEEE';

  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="40" height="40" rx="20" fill={fill} />
      <path
        d="M27.5 11.75H12.5C12.0858 11.75 11.75 12.0858 11.75 12.5V27.5C11.75 27.9142 12.0858 28.25 12.5 28.25H27.5C27.9142 28.25 28.25 27.9142 28.25 27.5V12.5C28.25 12.0858 27.9142 11.75 27.5 11.75Z"
        stroke="#3F3C43"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M24.5 10.25V13.25" stroke="#3F3C43" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.5 10.25V13.25" stroke="#3F3C43" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.75 16.25H28.25" stroke="#3F3C43" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default DateOrDay;
